<template>
  <div class="lp-base" :class="`lp-base--${lpId}`">
    <component
      :is="targetComp"
      :lp-id="lpId"
      :menus-list="menusList"
      :menus-tab-list="menusTabList"
      :target-info="targetInformation"
      :color-scheme="targetColorScheme"
      :hide-addvertise="hideAdvertise"
      :subsc-url="subscUrl"
      :sales-invalid="salesInvalid"
      :token="token"
      :subscription-status="subscriptionStatus"
    />
    <lp-footer :color-scheme="targetColorScheme" :menu-list="footerMenuList" :has-floating-banner="showFloatingBanner" :scroll-pos="scrollPos"/>
    <floating-banner-base :show-floating-banner="showFloatingBanner">
      <floating-banner-inner
        :banner-info="targetInformation.floatingBanner"
        :subsc-url="subscUrl"
        :lp-id="lpId"
        :sales-invalid="salesInvalid"
      />
    </floating-banner-base>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { BASIC_DATA, DEFAULT_FOOTER_MENULIST } from './commons'
import LpKurenotori from './counselor/kurenotori/LpMain'
import LpKanoucoco from './counselor/kanoucoco/LpMain'
import LpTouwa from './counselor/touwa/LpMain'
import LpHouen from './counselor/houen/LpMain'
import LpOttimo from './counselor/ottimo/LpMain'
import LpSomarimone from './counselor/somarimone/LpMain'
import LpFooter from './blocks/LpFooter'
import FloatingBannerBase from './partials/FloatingBannerBase'
import FloatingBannerInner from './partials/FloatingBannerInner'
// import DetailView from '@/utvStore/components/partials/DetailView'

export default {
  name: 'RecommendLpManager',
  //components: {LpFooter, DetailView},
  components: {LpFooter, FloatingBannerBase, FloatingBannerInner},
  props: {
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    lpId: {
      type: Number,
      default: 1,
    },
    targetCpno: {
      type: String,
      default: '',
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    token:{
      type: String,
      default: '',
    },
    subscUrl:{
      type: String,
      default: '/'
    },
  },
  data(){
    return {
      scrollPos: -1,
      showFloatingBannerStart: 0,
      documentLoaded: false,
    }
  },
  computed: {
    showFloatingBanner(){
      const flg = !!this.targetInformation && !!this.targetInformation.floatingBanner && this.targetInformation.floatingBanner.enable && this.documentLoaded
      const contH = document.body.clientHeight
      const  lim = window.innerHeight + 400
      const start = this.showFloatingBannerStart
      return flg && (this.scrollPos < contH - lim) && (this.scrollPos >= start)
    },
    hideAdvertise(){
      /*
       */
      const targets = [
        // ■暮れの酉さん
        '990000000214',
        // ■叶ここさん
        '990000000224',
        // ■斗弥さん
        '990000000234',
        // ■法演さん
        '990000000244',
      ]
      return targets.some(cpno => cpno === this.targetCpno)
    },
    targetColorScheme(){
      switch (this.lpId) {
        case 1: return BASIC_DATA.kurenotori.colorScheme
        case 2: return BASIC_DATA.kanoucoco.colorScheme
        case 3: return BASIC_DATA.touwa.colorScheme
        case 4: return BASIC_DATA.houen.colorScheme
        case 5: return BASIC_DATA.ottimo.colorScheme
        case 6: return BASIC_DATA.somarimone.colorScheme
      }
    },
    targetInformation(){
      switch (this.lpId) {
        case 1: return BASIC_DATA.kurenotori.information
        case 2: return BASIC_DATA.kanoucoco.information
        case 3: return BASIC_DATA.touwa.information
        case 4: return BASIC_DATA.houen.information
        case 5: return BASIC_DATA.ottimo.information
        case 6: return BASIC_DATA.somarimone.information
      }
    },
    targetComp(){
      switch (this.lpId) {
        case 1: return LpKurenotori
        case 2: return LpKanoucoco
        case 3: return LpTouwa
        case 4: return LpHouen
        case 5: return LpOttimo
        case 6: return LpSomarimone
      }
    },
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      subscriptionStatus: state => state.account.subscription.status
    })
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.targetColorScheme)
    console.log('menusList & tablist from server: %O %O', this.menusList, this.menusTabList)
  },
  mounted() {
    window.addEventListener('load', this.setShowFloatingBannerStart)
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('load', this.setShowFloatingBannerStart)
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(){
      this.scrollPos = window.scrollY
    },
    setShowFloatingBannerStart() {
      if (this.lpId == 3) {
        const elem = document.querySelector('.block-fortune-input')
        const elemBottom = elem.getBoundingClientRect().bottom + window.pageYOffset
        this.showFloatingBannerStart = elemBottom
      }
      this.documentLoaded = true
    },
  },
}</script>

<style scoped lang="scss">
//LP内 各ブロックの基本設定
/deep/ .basic-block {
  width: 100%;
  max-width: 580px;
  // background: #fcc;
  margin: 0 auto;
  // padding: 16px;
  // border-bottom: 1px solid #bbb;
  position: relative;
  z-index: 1;
  .content-wrap {
    width: 100%;
    position: relative;
    z-index: 100;
  }

  h1,h2,h3,h4,h5,h6{
    // margin: 0 0 16px;
  }
}
.lp-base {
  &--3 {
    /deep/ .lp-footer {
      background: #9C8961;
    }
  }
}
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/RecommendLpManager.vue